<menu-data-manager></menu-data-manager>
<div id="page-wrapper" class="gray-bg">
  <ng-transclude></ng-transclude>
</div>
